import { call, put } from 'redux-saga/effects';
import { getPropertyObjectsShort } from 'modules/App/services/API';
import { getPropertyObjectsFailure, getPropertyObjectsSuccess } from '../redux/actions';

export function* propertyObjectsSaga({ payload }) {
  const { isOk, data, error } = yield call(getPropertyObjectsShort, payload);

  if (isOk) {
    yield put(getPropertyObjectsSuccess({ data, isDefault: payload.isDefault }));
  } else {
    yield put(getPropertyObjectsFailure(error));
  }
}
